import React, { SVGProps } from 'react';
import { styled } from '@mui/material/styles';

const Path = styled('path')<{ heatmapcolourname: string | null }>(
  ({ heatmapcolourname, theme: { palette } }) => ({
    fill: heatmapcolourname
      ? palette.heatmap[
          heatmapcolourname as unknown as keyof typeof palette.heatmap
        ].avgScore
      : palette.heatmap.amber.avgScore,
  })
);

interface ReadinessScoreImageProps extends SVGProps<SVGSVGElement> {
  heatmapcolourname: string | null;
}

const ReadinessScoreImage = ({
  heatmapcolourname,
  ...props
}: ReadinessScoreImageProps): JSX.Element => (
  <svg
    {...props}
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      height="24"
      id="mask0_10620_106802"
      maskUnits="userSpaceOnUse"
      width="25"
      x="0"
      y="0"
    >
      <rect fill="#D9D9D9" height="24" width="24" x="0.5" />
    </mask>
    <g mask="url(#mask0_10620_106802)">
      <Path
        d="M7.875 21.025C7.275 21.0083 6.70417 20.8542 6.1625 20.5625C5.62083 20.2708 5.10833 19.8417 4.625 19.275C3.95833 18.475 3.4375 17.5208 3.0625 16.4125C2.6875 15.3042 2.5 14.1667 2.5 13C2.5 11.6167 2.7625 10.3167 3.2875 9.1C3.8125 7.88333 4.525 6.825 5.425 5.925C6.325 5.025 7.38333 4.3125 8.6 3.7875C9.81667 3.2625 11.1167 3 12.5 3C13.8833 3 15.1833 3.26667 16.4 3.8C17.6167 4.33333 18.675 5.05833 19.575 5.975C20.475 6.89167 21.1875 7.96667 21.7125 9.2C22.2375 10.4333 22.5 11.7583 22.5 13.175C22.5 14.4583 22.2917 15.6583 21.875 16.775C21.4583 17.8917 20.8667 18.8333 20.1 19.6C19.6333 20.0667 19.1417 20.4208 18.625 20.6625C18.1083 20.9042 17.5833 21.025 17.05 21.025C16.75 21.025 16.45 20.9875 16.15 20.9125C15.85 20.8375 15.55 20.725 15.25 20.575L13.85 19.875C13.65 19.775 13.4375 19.7 13.2125 19.65C12.9875 19.6 12.75 19.575 12.5 19.575C12.25 19.575 12.0125 19.6 11.7875 19.65C11.5625 19.7 11.35 19.775 11.15 19.875L9.75 20.575C9.43333 20.7417 9.12083 20.8625 8.8125 20.9375C8.50417 21.0125 8.19167 21.0417 7.875 21.025ZM7.925 19.025C8.075 19.025 8.22917 19.0083 8.3875 18.975C8.54583 18.9417 8.7 18.8833 8.85 18.8L10.25 18.1C10.6 17.9167 10.9625 17.7833 11.3375 17.7C11.7125 17.6167 12.0917 17.575 12.475 17.575C12.8583 17.575 13.2417 17.6167 13.625 17.7C14.0083 17.7833 14.375 17.9167 14.725 18.1L16.15 18.8C16.3 18.8833 16.45 18.9417 16.6 18.975C16.75 19.0083 16.9 19.025 17.05 19.025C17.3667 19.025 17.6667 18.9417 17.95 18.775C18.2333 18.6083 18.5167 18.3583 18.8 18.025C19.3333 17.3917 19.75 16.6333 20.05 15.75C20.35 14.8667 20.5 13.9583 20.5 13.025C20.5 10.7917 19.725 8.89583 18.175 7.3375C16.625 5.77917 14.7333 5 12.5 5C10.2667 5 8.375 5.78333 6.825 7.35C5.275 8.91667 4.5 10.8167 4.5 13.05C4.5 14 4.65417 14.925 4.9625 15.825C5.27083 16.725 5.7 17.4833 6.25 18.1C6.53333 18.4333 6.80833 18.6708 7.075 18.8125C7.34167 18.9542 7.625 19.025 7.925 19.025ZM12.5 15C13.05 15 13.5208 14.8042 13.9125 14.4125C14.3042 14.0208 14.5 13.55 14.5 13C14.5 12.8667 14.4875 12.7333 14.4625 12.6C14.4375 12.4667 14.4 12.3333 14.35 12.2L15.6 10.525C15.7667 10.7417 15.9125 10.9708 16.0375 11.2125C16.1625 11.4542 16.2667 11.7167 16.35 12H18.4C18.15 10.5333 17.4708 9.33333 16.3625 8.4C15.2542 7.46667 13.9667 7 12.5 7C11.0333 7 9.74167 7.47083 8.625 8.4125C7.50833 9.35417 6.83333 10.55 6.6 12H8.65C8.88333 11.1 9.35833 10.375 10.075 9.825C10.7917 9.275 11.6 9 12.5 9C12.7833 9 13.05 9.025 13.3 9.075C13.55 9.125 13.7917 9.2 14.025 9.3L12.75 11.025C12.7167 11.025 12.675 11.0208 12.625 11.0125C12.575 11.0042 12.5333 11 12.5 11C11.95 11 11.4792 11.1958 11.0875 11.5875C10.6958 11.9792 10.5 12.45 10.5 13C10.5 13.55 10.6958 14.0208 11.0875 14.4125C11.4792 14.8042 11.95 15 12.5 15Z"
        heatmapcolourname={heatmapcolourname}
      />
    </g>
  </svg>
);

export default ReadinessScoreImage;
